import { clearAuthToken, getAuthToken } from "./auth";
import axios from "axios";
const Base_Url = process.env.REACT_APP_BASE_URL;

export const fetchLoginUser = async (setUserData) => {
  try {
    console.log(">>");

    const token = getAuthToken();
    if (token) {
      axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
      const res = await axios.get(`${Base_Url}/api/user`);
      const userData = res.data.user;
      setUserData(userData);
      return userData;
    }
  } catch (err) {
    console.error(err.response?.status);
    if (err.response?.status === 401 || err.response?.status === 404) {
      await clearAuthToken();
      window.location.href = "/login";
    }
  }
};

export const fetchAllUsers = async (
  page,
  limit,
  searchEmail,
  setUsers,
  setTotalPages
) => {
  try {
    const token = getAuthToken();
    if (token) {
      axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
      const res = await axios.get(`${Base_Url}/api/user/all`, {
        params: { page, limit, search: searchEmail },
      });
      setUsers(res.data.users);
      setTotalPages(res.data.totalPages);
    }
  } catch (e) {
    console.log(e);
  }
};

export const fetchSingleUser = async (id, setUser) => {
  try {
    const res = await axios.get(`${Base_Url}/api/user/id/${id}`);
    setUser(res.data.user);
  } catch (e) {
    console.log(e);
  }
};

export const fetchSingleUserPosts = async (
  id,
  setPosts,
  page,
  limit,
  setTotalPages,
  search
) => {
  try {
    const role = localStorage.getItem("role");
    const res = await axios.get(
      `${Base_Url}/api/user/posts/${id}?page=${page}&limit=${limit}&search=${search}&role=${role}`
    );
    setPosts(res.data.posts);
    setTotalPages(res.data.totalPages);
  } catch (e) {
    console.log(e);
  }
};

export const fetchSingleUserDonations = async (
  id,
  setPosts,
  page,
  limit,
  setTotalPages,
  search
) => {
  try {
    const res = await axios.get(
      `${Base_Url}/api/donations/user/${id}?page=${page}&limit=${limit}&search=${search}`
    );
    setPosts(res.data.posts);
    setTotalPages(res.data.totalPages);
  } catch (e) {
    console.log(e);
  }
};
